import axios from "axios";
import * as moment from "moment";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { parseTaskModel } from "../task/model";

const apiUrl = "/api/actionabletask";
let cancelAbortController = new AbortController();
let getCountAbortController = new AbortController();

const getAll = async (
    userIds: string[],
    teamIds: string[],
    customerIds: string[],
    taskCategories: string[],
    taskTypes: string[],
    dueDate: moment.Moment,
    includeWithoutDueDates: boolean,
    includeAssignedTasks: boolean): Promise<TaskModel[]> => {
    const dueDateParam = dueDate.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
    cancelAbortController.abort();
    cancelAbortController = new AbortController();

    const response = await axios.get(`${apiUrl}`, {
        params: {
            userIds,
            teamIds,
            customerIds,
            taskCategories,
            taskTypes,
            includeWithoutDueDates,
            includeAssignedTasks,
            dueDateLocal: dueDateParam
        },
        signal: cancelAbortController.signal
    });
    const data = response.data as TaskModel[];
    return data.map(parseTaskModel);
};

const getCount = async (
    userIds: string[],
    teamIds: string[],
    customerIds: string[],
    taskCategories: string[],
    taskTypes: string[],
    dueDate: moment.Moment,
    includeWithoutDueDates: boolean,
    includeAssignedTasks: boolean): Promise<{ totalCount: number }> => {
    const dueDateParam = dueDate.format(moment.HTML5_FMT.DATETIME_LOCAL);

    getCountAbortController.abort();
    getCountAbortController = new AbortController();

    const response = await axios.get(`${apiUrl}/count`, {
        params: {
            userIds,
            teamIds,
            customerIds,
            taskCategories,
            taskTypes,
            dueDate: dueDateParam,
            includeWithoutDueDates,
            includeAssignedTasks
        },
        signal: getCountAbortController.signal
    });
    return response.data;
};

const getTaskTypes = async (taskCategories: string[], abortController: AbortController) => {
    return (await axios.get<ServerModelWithDateStrings<{ type: string; description: string }>[]>(
        `${apiUrl}/TaskTypes`,
        {
            params: { taskCategories },
            signal: abortController.signal
        }
    )).data;
};

const assignUsersToActionableTasks = (selectedTasks: TaskModel[], users: { id: string; name: string }[]) => {
    const tasks = selectedTasks.map(t => {
        return {
            caseId: t.caseId,
            id: t.id
        };
    });
    return axios.post(`${apiUrl}/assignedUsers`, { tasks, users });
};

export const ActionableTasksApi = { getAll, getTaskTypes, assignUsersToActionableTasks, getCount };
